import React from 'react';
import {Redirect} from 'react-router-dom';
import { connect } from 'react-redux';
import * as auth from '../../imports/auth';
import { loginActionCreators } from '../login-register/LoginActions';


function Logout(props) {
    props.resetLoginStep()
    auth.logout();
    window.location = '/'
    return (
        <Redirect to="/" />
    );
}


const mapStateToProps = state => ({
    
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    resetLoginStep: () => {
        dispatch(loginActionCreators.changeStep(1));
    }
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Logout);